<div class="app d-flex align-items-center h-100 animated fadeIn enin-backdrop">
  <div class="container">
    <div class="row justify-content-center">
      <div class="{{ columnClasses() }} {{ andClass() }}">
        <div class="text-center mb-4">
          <img rel="Enin Logo" src="app/assets/img/logo_black.svg" class="mb-3" height="47" />
        </div>
        <nk-card andClass="material-shadow-4">
          <nk-card-content andClass="m-3">
            <ng-content></ng-content>
          </nk-card-content>
        </nk-card>
      </div>
    </div>
  </div>
</div>
